export const JOB_SEARCH_FILTER_TYPES = Object.freeze({
    COMPANY: 'company_id',
    COMPANY_SIZE: 'company_size',
    COMPANY_NAME: 'company_name',
    LOCATION: 'locations',
    QUICK_APPLY: 'quick_apply',
    REMOTE: 'remote',
});
